import React from 'react';
import sidebar2 from "../assets/images/giaodienmini_game_tet_2026/00. Footage landingpage Minigame/Side-bar2.png";

export default function Boxtitle({children}) {
    return (
        <div
            className="relative w-full max-w-[400px] mx-auto"
            style={{
                backgroundImage: `url(${sidebar2})`,
                backgroundSize: '100% 100%',
                backgroundRepeat: 'no-repeat',
                minHeight: '500px',
                padding: '40px 40px'
            }}
        >
            {children}
        </div>
    );
}